import { Box } from '@mui/material';

import routes from '@/assets/constants/routes-no.ts';
import { ArrowLink } from '@/competitions/_common/components/ArrowLink.tsx';
import { UnderlinedText } from '@/components/UnderlinedText/index.ts';
import { sendUserPortalEvent } from '@/lib/analytics/unified.ts';
import type { CompetitionWithConfig } from '@/lib/api/requests.ts';
import { Timer, type TimerTheme } from '@/ui/Timer.tsx';

import { WAKE_UP_PART2_2024_CAMPAIGN_END_DATE } from '../../../config.ts';
import { CTA } from '../_components/CTA.tsx';
import { Section } from '../_components/Section.tsx';

const dateFormatter = new Intl.DateTimeFormat('no', {
  day: 'numeric',
  month: 'long',
});
const dateStr = dateFormatter.format(WAKE_UP_PART2_2024_CAMPAIGN_END_DATE);

const timerTheme: TimerTheme = {
  backgroundColor: '#355383',
  digitsColor: '#FFFFFF',
  labelsColor: '#F0F4FA',
};

export const TimerSection2 = (props: { activeCompetition: CompetitionWithConfig | undefined }) => {
  return (
    <Section
      sx={{
        gap: '20px',
        flexDirection: { md: 'row' },
        flexWrap: { md: 'wrap', xl: 'initial' },
      }}
    >
      <Box
        sx={{
          textAlign: { xs: 'center', xl: 'left' },
          flex: { xl: 1.15 },
          width: { md: '100%', xl: 'auto' },
          mb: { md: 2 },
          pr: { xl: 8 },
          mt: { xl: 4 },
        }}
      >
        <div className="mb-6 typography-v1-h1">
          16. oktober fikk en heldig vinner våkne gjeldfri!
        </div>

        <p className="mx-auto mb-4 max-w-[70ch] typography-v1-body3">
          Det var så stor interesse rundt kampanjen, så vi har bestemt oss for at vi skal trekke en
          til!
          <br />
          Deltok du i kampanjen om å våkne gjeldfri i september, er du automatisk med i denne
          trekningen også.
        </p>

        <CTA
          activeCompetition={props.activeCompetition}
          onClick={() => {
            sendUserPortalEvent('wake24_competition_cta_timer_clicked');
          }}
        />
      </Box>
      <Box
        sx={{
          bgcolor: (theme) => theme.palette.background.default,
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '8px',
          flex: { md: 1 },
        }}
      >
        <p className="mb-4 typography-v1-h2">Premie</p>
        <p className="-mb-1 typography-v1-h2">Få slettet inntil</p>
        <p className="mb-6 typography-v1-display">
          <UnderlinedText>500 000</UnderlinedText>&nbsp;kr
        </p>
        <p className="mb-10 typography-v1-h3">av din forbruks- og kredittkortgjeld</p>

        <p className="mt-auto mb-4 typography-v1-body3">
          Vi nedbetaler din forbruks- og kredittkortgjeld dersom du vinner. Maks. 500 000 kr
        </p>

        <ArrowLink
          to={routes.WAKE_UP_PART2_2024_COMPETITION_TERMS}
          sx={{ display: 'block', my: 2, mt: { sm: 3 } }}
        >
          Vilkår og betingelser
        </ArrowLink>
      </Box>
      <Box
        sx={{
          bgcolor: (theme) => theme.palette.background.contrast,
          color: (theme) => theme.palette.common.white,
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '8px',
          flex: { md: 1 },
        }}
      >
        <p className="typography-v1-h2">Trekningsdato</p>
        <p className="mt-4 mb-8 typography-v1-display leading-none lg:text-[3.812rem]">{dateStr}</p>
        <Timer date={WAKE_UP_PART2_2024_CAMPAIGN_END_DATE} theme={timerTheme} />

        <p className="mt-6 mb-4 typography-v1-body3 md:mt-8 xl:mt-12">
          Vinnerne kontaktes via e-post og mobil. Vi tar hensyn til personvern og publiserer ikke
          vinnere uten samtykke.
        </p>

        <ArrowLink
          to={routes.WAKE_UP_PART2_2024_COMPETITION_TERMS}
          sx={{ display: 'block', my: 2, mt: { sm: 3 } }}
        >
          Vilkår og betingelser
        </ArrowLink>
      </Box>
    </Section>
  );
};
